import { cn } from "@/lib/cn"

// First-letter avatar with the brand red→panel gradient. Two sizes:
//   sm — 11x11 (table rows)
//   md — 14x14 (selected-agent panel header)
type Props = {
  name: string
  size?: "sm" | "md"
  className?: string
}

const SIZE = {
  sm: "h-11 w-11 text-base",
  md: "h-14 w-14 text-xl",
}

export function AgentAvatar({ name, size = "sm", className }: Props) {
  const initial = (name[0] ?? "?").toUpperCase()
  return (
    <div
      className={cn(
        "flex items-center justify-center rounded-control bg-gradient-to-br from-brand-red to-app-panel2 font-semibold text-white shadow-redGlow",
        SIZE[size],
        className,
      )}
    >
      {initial}
    </div>
  )
}
